export type TEnvironment = "production" | "staging" | "latest" | "development";
export const APP_ENV = (process.env.REACT_APP_APP_ENV ??
  "development") as TEnvironment;
export const IS_PRODUCTION = APP_ENV === "production";
export const API_HOST_URL =
  process.env.REACT_APP_API_HOST_URL ?? "https://staging-api.hackthenorth.com";
export const ENDPOINT = `${API_HOST_URL}/v3/graphql`;

console.debug(APP_ENV);

export const IS_LOCAL_API = ["localhost", "127.0.0.1"].includes(
  new URL(API_HOST_URL).hostname
);
